import React, { FC, useState } from 'react'
import classNames from 'classnames'
import { getStyledElementProps } from '@/utils'
import { Icon } from '../../atoms/icon'
import { Button } from '../../atoms/button'
import { ButtonIconProps } from '@/types'

import buttonIconStyles from './button-icon.module.scss'

export const ButtonIcon: FC<ButtonIconProps> = ({
  children,
  iconPosition = 'end',
  iconName = 'play_arrow',
  iconHoverName = iconName,
  iconColor = 'white',
  ...props
}) => {
  const styledContainerProps = getStyledElementProps(
    props,
    classNames(buttonIconStyles['container'])
  )
  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  const getIconName = () => {
    return isHovered ? iconHoverName : iconName
  }

  const getIcon = () => (
    <Icon name={getIconName()} color={iconColor} size={props.size} />
  )
  return (
    <Button
      {...styledContainerProps}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {iconPosition === 'start' && getIcon()}
      {children}
      {iconPosition === 'end' && getIcon()}
    </Button>
  )
}
